var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFlueidclear(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "47px",
    viewBox: "0 0 47 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Media",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flueid-Desktop-Media",
    transform: "translate(-231.000000, -2985.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0.000000, 2611.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(230.000000, 374.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11-Copy",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44,0 C45.6568542,0 47,1.34314575 47,3 L47,44 C47,45.6568542 45.6568542,47 44,47 L3,47 C1.34314575,47 0,45.6568542 0,44 L0,3 C0,1.34314575 1.34314575,0 3,0 L44,0 Z M43.8,3.2 L3.2,3.2 L3.2,43.8 L43.8,43.8 L43.8,3.2 Z M29.2057898,11 C30.4301827,11 31.4237288,11.9869434 31.4237288,13.2031993 C31.4237288,14.4183312 30.4301827,15.4052745 29.2057898,15.4052745 C24.3693249,15.4052745 20.4347464,19.3384349 20.4347464,24.1731085 L20.4347464,24.1731085 L20.4347464,26.3111111 L29.2057898,26.3111111 C30.4301827,26.3111111 31.4237288,27.2969304 31.4237288,28.5143104 C31.4237288,29.7294423 30.4301827,30.7163856 29.2057898,30.7163856 L29.2057898,30.7163856 L20.4347464,30.7163856 L20.4347464,37 C18.7724237,36.7583225 17.2911573,36.5177691 16,36.295201 L16,36.295201 L16,24.1731085 C16,16.9092953 21.923934,11 29.2057898,11 Z",
    id: "Combined-Shape"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlueidclear);
export default __webpack_public_path__ + "static/media/icon-flueid.clear.e50a8e7913124329be77d419f86f656f.svg";
export { ForwardRef as ReactComponent };